import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../../../../components";
import { formatDate } from "../../../../utils/date-formatter";
import {
  TabContent,
} from "./styles";
import {
  InfoSection,
  InfoRow,
  InfoLabel,
  InfoValue,
  ActionsSection,
  InfoGrid,
} from "./overview-styles";

type OverviewTabProps = {
  project: any;
  reloadProject: () => void;
};

const OverviewTab: FC<OverviewTabProps> = ({ project, reloadProject }) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  return (
    <TabContent>
      <InfoSection>
        <InfoGrid>
          <InfoRow>
            <InfoLabel>{t("PROJECT_NAME")}:</InfoLabel>
            <InfoValue>{project.name}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("PROJECT_ID")}:</InfoLabel>
            <InfoValue>{project.project_id}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("DESCRIPTION")}:</InfoLabel>
            <InfoValue>{project.description || t("NONE")}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("STATUS")}:</InfoLabel>
            <InfoValue>
              {project.disabled ? t("DISABLED") : (project.deleted ? t("DELETED") : t("ENABLED"))}
            </InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("DOMAIN_ID")}:</InfoLabel>
            <InfoValue>{project.project_domain_id}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("IS_DOMAIN")}:</InfoLabel>
            <InfoValue>{project.is_domain ? t("YES") : t("NO")}</InfoValue>
          </InfoRow>

          {project.service && (
            <InfoRow>
              <InfoLabel>{t("SERVICE")}:</InfoLabel>
              <InfoValue>
                <Link to={`/billing/services/${project.service}`} style={{ color: 'inherit', textDecoration: 'underline' }}>
                  {t("SERVICE_DETAILS")}
                </Link>
              </InfoValue>
            </InfoRow>
          )}

          <InfoRow>
            <InfoLabel>{t("SERVICES_COUNT")}:</InfoLabel>
            <InfoValue>{project.services_count || 0}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("CREATED_AT")}:</InfoLabel>
            <InfoValue>{formatDate(project.created_at)}</InfoValue>
          </InfoRow>

          <InfoRow>
            <InfoLabel>{t("UPDATED_AT")}:</InfoLabel>
            <InfoValue>{formatDate(project.updated_at)}</InfoValue>
          </InfoRow>
        </InfoGrid>
      </InfoSection>

      <ActionsSection>
        <Button
          variant="secondary"
          size="medium"
          title={t("EDIT_PROJECT")}
          onClick={() => navigate(`/openstack/projects/${project.id}/edit`)}
        />
        <Button
          variant="primary"
          size="medium"
          title={t("EDIT_QUOTAS")}
          onClick={() => navigate(`/openstack/projects/${project.id}/quotas`)}
        />
      </ActionsSection>
    </TabContent>
  );
};

export default OverviewTab;
